import Sliders from './src/sliders-combined';
export default Sliders;